module.exports = __webpack_public_path__ + "static/First-01-4f2d1069849c20f62ad54ae9a2e0e628.jpg";